import { Component, ElementRef, EventEmitter, Input, Output } from "@angular/core";
import { Order } from "../../../../objects/orders/order";
import { OrderSearch } from "../../../../objects/responses/orderSearch";
import { LocationUtil } from "../../../../common/utils/LocationUtil";
import { CalculatorHelper } from "../../../../common/helpers/calculatorHelper";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfigService } from "../../../../services/configService";
import { PaginationInstance } from "ngx-pagination";
import { CanadianCurrencyCode } from "../../../../objects/currencyExchange/canadianCurrencyCode";
import { OrderStatus } from "../../../../objects/orders/orderStatus";
import { OrderHelper } from "../../../../common/helpers/orderHelper";
import { UserViewService } from "../../../../services/userViewService";
import { Component as ComponentEnum } from "../../../../objects/components/component";
import { OrderViewType } from "../../../../objects/management/order/orderViewType";
import { Column, SortType } from "../../../../objects/users/user";


@Component({
    selector: 'order-table-view',
    templateUrl: 'order-table-view.component.html',
    moduleId: module.id.toString(),

})
export class OrderTableViewComponent {

    @Input()
    public config: PaginationInstance;

    @Input()
    private paramsInUrl: OrderSearch = new OrderSearch();

    @Input()
    public orders: Order[] = [];

    @Input()
    isLoading: boolean;

    @Input()
    public tableColumns: any[];

    @Output()
    public searchEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

    readonly headerHeight = 60;
    readonly rowHeight = 50;

    public orderStatus = OrderStatus;
    public orderHelper = OrderHelper;

    public canadianCurrencyCodes: CanadianCurrencyCode[];

    public get getColumns() : Column[]{
        const currentView = this.userViewService.userView[ComponentEnum.OrderManagement];

        const columnsConfig = currentView.ColumnsConfigs.find(x => x.Type == OrderViewType.Table);

        return columnsConfig.Columns;
    }

    public get getSortedColumn(): any {
        const currentView = this.userViewService.userView[ComponentEnum.OrderManagement];
        const columnsConfig = currentView.ColumnsConfigs.find(x => x.Type == OrderViewType.Table);

        const sortedColumn = columnsConfig.Columns.find(c => c.SortType != SortType.None);

        return [{
            prop: sortedColumn.Property,
            dir: sortedColumn.SortType == SortType.Desc ? 'desc' : 'asc'
        }];
    }

    constructor(private route: ActivatedRoute,
                private configService: ConfigService,
                private el: ElementRef,
                private router: Router,
                private userViewService: UserViewService) {
        this.canadianCurrencyCodes = this.route.snapshot.data.canadianCurrencyCodes.Data;
    }

    public onScroll(scrollY: any) {
        if (!scrollY || !scrollY.offsetY)
            return;

        // total height of all rows in the viewport
        const viewHeight = this.el.nativeElement.getBoundingClientRect().height - this.headerHeight;

        if (this.config.currentPage * this.config.itemsPerPage >= this.config.totalItems)
            return;

        if (viewHeight + scrollY.offsetY >= this.orders.length * this.rowHeight) {
            this.isLoading = true;

            this.config.currentPage++;

            this.searchEvent.emit(false);
        }

    }

    public onRowClicked(event: any) {
        if (event.type == "click") {
            const order = event.row as Order;
            this.goToDetailsBase(order.Id, this.paramsInUrl, order);
        }
    }

    public goToDetailsBase(id: number, orderSearch: OrderSearch, order: Order): void {
        this.router.navigate([`order/${id.toString()}`, {
            query: orderSearch.Query ? orderSearch.Query : "",
            agentid: orderSearch.AgentId ? orderSearch.AgentId.toString() : "",
            customerid: order.Customer && order.Customer.Id ? order.Customer.Id.toString() : ""
        }]);
    }

    public handleSort(event: any): void {
        const columns = this.getColumns;

        columns.forEach(c => c.SortType = SortType.None);

        const currentColumn = columns.find(c => c.Name == event.column.name);

        currentColumn.SortType = event.newValue == 'desc' ? SortType.Desc : SortType.Asc;

        this.userViewService.modify(this.userViewService.userView[ComponentEnum.OrderManagement]).then(resp => {
            this.userViewService.userView[ComponentEnum.OrderManagement] = resp.Data;

            this.searchEvent.emit(true);
        });
    }

    public isSortable(prop: string): boolean {
        return prop != "''";
    }
}



// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/tableView/order-table-view.component.ts